import TextInput from '../../../Shared/TextInput/TextInput';
import React, { useState, useEffect } from 'react';
import { Container, Row, Button, ButtonGroup, Input, InputGroup, Label, FormGroup } from 'reactstrap';
import { DATA_TRANSFER_ENUM } from '../IdfSaleEnums';
import RadioInput from '../../../Shared/RadioInput/RadioInput';
import Terms from '../Constans/Terms';
import Checkbox from 'app/Components/Shared/CheckBox/Checkbox';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { TermsDataPartThree } from '../Constans/TermsData';
import { connect } from 'react-redux';

function JoiningFormPopUp(props) {
  const { first_name: firstName, last_name: lastName, id_number: idNumber, idfid_number: idfIdNumber } = props.idfStore.userDetails;
  const { idfStore } = props;
  const { joiningForm } = idfStore;
  const [isContinueClicked, setIsContinueClicked] = useState(false);
  const isDisabled = props.isDisabled || false
  const [formErrors, setFormErrors] = useState({
    radioBtns: false,
    personDataMove: false,
    acceptDataDownload: false,
    acceptTerms: false,
    acceptTermsName: false,
    signedWillingly: false,
    signedWillinglyName: false,
  });

  const validateForm = () => {
    return {
      radioBtns: !joiningForm.move_data_by_law && !joiningForm.move_data_to_person && !joiningForm.dont_move_data,
      personDataMove: joiningForm.move_data_to_person && (!joiningForm.person_data_move || joiningForm.person_data_move === ''),
      acceptDataDownload: !joiningForm.accept_data_download,
      acceptTerms: !joiningForm.accept_terms,
      acceptTermsName: joiningForm.accept_terms && (!joiningForm.sign_name_terms || joiningForm.sign_name_terms === ''),
      signedWillingly: !joiningForm.i_have_signed_willingly,
      signedWillinglyName: joiningForm.i_have_signed_willingly && (!joiningForm.sign_name_willing || joiningForm.sign_name_willing === ''),
    };
  };

  useEffect(() => {
    if (isContinueClicked) {
      setFormErrors(validateForm());
    }
  }, [joiningForm, isContinueClicked]);

  const onClickContinue = () => {
    setIsContinueClicked(true);
    const errors = validateForm();
    setFormErrors(errors);
    if (Object.values(errors).every((error) => !error)) {
      props.setIsJoiningFormValid(true);
      props.setIsShowPopUp(false);
    } else {
      props.setIsJoiningFormValid(false);
    }
  };

  return (
    <div className='services-and-joining-form-pop-up'>
      <div className='popup-title'>
        <Row className='idf-title-bold justify-content-center d-flex'>טופס הצטרפות</Row>
        <Row className='idf-line justify-content-center d-flex'></Row>
        {!isDisabled && <div className='idf-sub-title-bold justify-content-center d-flex' style={{ width: '85%' }}>
          {' '}
          מלאו את הפרטים ואשרו את הטופס בסוף העמוד
        </div>}
      </div>
      <div className='info-disabled-inputs-container'>
        <TextInput onChange={() => { }} className='mb-2' value={!isDisabled ? firstName + ' ' + lastName : firstName} placeholder='שם מלא' disabled={true}></TextInput>
        <TextInput onChange={() => { }} className='mb-2' value={idNumber} placeholder='תעודת זהות' disabled={true}></TextInput>
        <TextInput
          onChange={() => { }}
          className='mb-2'
          value={idfIdNumber}
          placeholder='ארבע ספרות אחרונות של המספר האישי'
          disabled={true}></TextInput>
      </div>

      <span className='text-center idf-sub-title-bold'>הריני מצהיר בזאת, כי:</span>
      {!(isDisabled && joiningForm.isNewAuctionSolider) && <Terms />}
      <div className=' grey-container '>
        <div className='terms-section'>
          <p className='num'> {Object.entries(TermsDataPartThree)[0][0]}</p>
          <p className='text'> {Object.entries(TermsDataPartThree)[0][1]}</p>
        </div>
        <FormGroup className='sub-agreement-container' check inline>
          <Checkbox
            id='agreementCheckbox'
            disabled
            onCheck={!isDisabled ? () => props.setSubAgreement(true) : () => { }}
            onUncheck={!isDisabled ? () => props.setSubAgreement(false) : () => { }}
            checked={props.idfStore.joiningForm.sub_agreement}
            label={
              'בנוסף, אני מעוניין בקבלת דברי פרסומת של סלקום בנושאים שאין שירותי תקשורת ורט"ן ואינם שירותים המתלווים להם באמצעות הודעות SMS MMS,מייל, פקס והודעות חיוג אוטומטיות.'
            }
          />
          {/* <Input className='' dir='rtl' type='checkbox' onChange={(e) => props.setSubAgreement(e.target.checked)} /> */}
          {/* <Label check>
            בנוסף, אני מעוניין בקבלת דברי פרסומת של סלקום בנושאים שאינם שירותי תקשורת ורט"ן ואינם שירותים המתלווים להם באמצעות הודעת MMS
            SMS, מייל, פקס והודעות חיוג אוטומטיות.
          </Label> */}
        </FormGroup>
      </div>
      <div className='grey-container data-transfer-inputs-container'>
        <div className='terms-section'>
          <p className='num'> {Object.entries(TermsDataPartThree)[1][0]}</p>
          <p className='text'> {Object.entries(TermsDataPartThree)[1][1]}</p>
        </div>

        {Object.entries(DATA_TRANSFER_ENUM).map(([key, value], i) => {
          let stateProperty = value.state;
          return (
            // eslint-disable-next-line react/jsx-key
            <div className='inputs-container'>
              <RadioInput
                checked={props.idfStore.joiningForm[stateProperty]}
                id={'radioLineType' + i}
                name={'lineType'}
                value={key}
                label={value.title}
                disabled
                onChange={!isDisabled ? () => props.setDataTransfer(value.state) : () => { }}
              />
              {props.idfStore.joiningForm.move_data_to_person && (
                <>
                  {value.state == DATA_TRANSFER_ENUM.TO_PERSON.state && (
                    <div className=''>
                      <TextInput
                        className={`mb-2 ${formErrors.personDataMove ? 'input-error' : ''}`}
                        onChange={(e) => props.setDataTransferName(e.target.value)}
                        value={props.idfStore.joiningForm.person_data_move}
                        name='id'
                        placeholder='שם מלא'
                        required='required'
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          );
        })}
        {formErrors.radioBtns && <div className={'error'}>יש לבחור באחת האפשרות</div>}
        {/* <FormGroup check inline> */}
        {/* <Input className='' dir='rtl' type='checkbox' onChange={(e) => props.setAcceptDataDownload(e.target.checked)} /> */}
        <div className={'checkbox-with-label-container'}>
          <Checkbox
            id='AcceptDataDownloadCheckbox'
            onCheck={!isDisabled ? () => props.setAcceptDataDownload(true) : () => { }}
            onUncheck={!isDisabled ? () => props.setAcceptDataDownload(false) : () => { }}
            checked={props.idfStore.joiningForm.accept_data_download}
            label={'אני מצהיר כי זהו רצוני ביחס להורדת המידע האגור במכשיר לאחר מותי'}
          />
        </div>
        {/* <Label check>אני מצהיר כי זהו רצוני ביחס להורדת המידע האגור במכשיר לאחר מותי</Label> */}
        {/* </FormGroup> */}
        {formErrors.acceptDataDownload && <div className={'error'}>לא ניתן להתקדם ללא סימון</div>}
      </div>
      <span className='text-center agree-title'>הצהרת משתמש</span>

      <div className='grey-container d-flex flex-column align-items-start justify-content-center py-2'>
        <div className='checkbox-input-container'>
          {/* <FormGroup check inline> */}
          <Checkbox
            id='AcceptTermsDownloadCheckbox'
            onCheck={!isDisabled ? () => props.setAcceptTerms(true) : () => { }}
            onUncheck={!isDisabled ? () => props.setAcceptTerms(false) : () => { }}
            checked={props.idfStore.joiningForm.accept_terms}
            label={'אני,'}
          />
          {/* <Input className='' dir='rtl' type='checkbox' onChange={(e) => props.setAcceptTerms(e.target.checked)} />
            <Label check>אני,</Label> */}
          {/* </FormGroup> */}
          <div className=''>
            <TextInput
              onChange={(e) => props.setSignNameTerms(e.target.value)}
              className={`mb-2 ${formErrors.acceptTermsName ? 'input-error' : ''}`}
              value={props.idfStore.joiningForm.sign_name_terms}
              name='id'
              disabled={isDisabled}
              placeholder='שם מלא'
              required='required'
            />
          </div>
        </div>
        {formErrors.acceptTerms && <div className={'error'}>לא ניתן להתקדם ללא סימון</div>}
        {formErrors.acceptTermsName && <div className={'error'}>יש להזין שם מלא</div>}
        <div className='terms-section'>
          <p> {Object.entries(TermsDataPartThree)[2][1]}</p>
        </div>
        <div className='checkbox-input-container'>
          <Checkbox
            id='IHaveSignedWillingly'
            onCheck={!isDisabled ? () => props.setIHaveSignedWillingly(true) : () => { }}
            onUncheck={!isDisabled ? () => props.setIHaveSignedWillingly(false) : () => { }}
            checked={props.idfStore.joiningForm.i_have_signed_willingly}
            label={'אני,'}
          />
          {/* <FormGroup check inline>
            <Input className='' dir='rtl' type='checkbox' onChange={(e) => props.setIHaveSignedWillingly(e.target.checked)} />
            <Label check>אני,</Label>
          </FormGroup> */}
          <div className=''>
            <TextInput
              onChange={(e) => {
                props.setSignNameWilling(e.target.value);
              }}
              value={props.idfStore.joiningForm.sign_name_willing}
              className={`mb-2 ${formErrors.signedWillinglyName ? 'input-error' : ''}`}
              name='id'
              disabled={isDisabled}
              placeholder='שם מלא'
              required='required'
            />
          </div>
        </div>
        {formErrors.signedWillingly && <div className={'error'}>לא ניתן להתקדם ללא סימון</div>}
        {formErrors.signedWillinglyName && <div className={'error'}>יש להזין שם מלא</div>}
        <div className='terms-section'>
          <p className='terms-text'> {Object.entries(TermsDataPartThree)[3][1]}</p>
        </div>
      </div>
      {!isDisabled && <BtnSubmit isBusiness text='אישור וחזרה לתהליך' onclick={() => onClickContinue()} />}
    </div>
  );
}
const mapStateToProps = (state) => ({
  idfStore: state.idfSale,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(JoiningFormPopUp);
